module.exports = __webpack_public_path__ + "static/media/our-office.ce525897.jpg";